export const groupedColors = {
  blue: {
    lightestBlue: '#F4F5F8',
    lightBlue: '#E7EBF0',
    powderBlue: '#DDE1E9',
    mainDarkBlueLight: '#F1F9FF',
    mainDarkBlue: '#C8E6FF',
    mainLightBlue: '#BEDAF2',
    lightSteelBlue: '#7788A7',
    darkestBlue: '#1D386C',
    navyBlue: '#162D5A',
    midnightBlue: '#12254A',
    mediumBlue: '#2F559F',
    darkSteelBlue: '#303A63',
    shinyBlue: '#0B72BD',
    strongBlue: '#0943B2',
  },
  gray: {
    white: '#FFFFFF', // ui6
    disabledOverlay: 'rgba(255, 255, 255, 0.7)',
    gainsboro: '#F0F1F2', // ui5
    lightGray: '#DCDDE0', // ui4
    darkGray: '#9D9FA1', // ui3
    dimGray: '#515254', // ui2
    darkestGray: '#1B1B1C', // ui1
  },
  pink: {
    lightestPink: '#FDF1F0',
    secondaryLightPurple: '#EDEBF6',
    pastelPink: '#F6C6C5',
    purple: '#ADA3DA',
    darkPurple: '#7C62C4',
  },
  yellow: {
    lightYellow: '#FFF7E5',
    midYellow: '#FFEFD9',
    darkYellow: '#FAD682',
  },
  green: {
    mainDarkGreenLight: '#F4FFFB',
    secondaryLightGreen: '#DDE9EB',
    mainLightGreen: '#DEFDF0',
    mainDarkGreen: '#D3F0E4',
    secondaryDarkGreen: '#1A6C78',
  },
  support: {
    lightGreen: '#E5F4EA',
    lightOrange: '#FFF4E5',
    lightRed: '#FCE7E7',
    skyBlue: '#E6F2FF',
    darkBlue: '#007AFF',
    darkGreen: '#00962B',
    darkOrange: '#FF9500',
    darkRed: '#E20D0D',
  },
};

export const colors = {
  ...groupedColors.blue,
  ...groupedColors.gray,
  ...groupedColors.pink,
  ...groupedColors.yellow,
  ...groupedColors.green,
  ...groupedColors.support,
};

export const buttonColors = {
  // Primary Button
  primaryButtonFontColorDefault: colors.white,
  primaryButtonBgDefault: colors.darkestBlue,
  primaryButtonBgHover: colors.navyBlue,
  primaryButtonBgFocus: colors.midnightBlue,
  primaryButtonBgDisabled: colors.lightSteelBlue,

  // Secondary Button
  secondaryButtonDefault: colors.darkestBlue,
  secondaryButtonHover: colors.navyBlue,
  secondaryButtonFocus: colors.midnightBlue,
  secondaryButtonDisabled: colors.lightSteelBlue,
  secondaryButtonBgHover: colors.lightestBlue,
  secondaryButtonBgFocus: colors.powderBlue,

  // Link Buttons
  linkDefault: colors.darkestBlue,
  linkHover: colors.navyBlue,
  linkFocus: colors.midnightBlue,
  linkDisabled: colors.lightSteelBlue,
};

export const supportColors = {
  supportColorConfirmation: colors.darkGreen,
  supportColorWarning: colors.darkOrange,
  supportColorAlert: colors.darkRed,
  supportColorInfo: colors.darkBlue,

  supportBgConfirmation: colors.lightGreen,
  supportBgWarning: colors.lightOrange,
  supportBgAlert: colors.lightRed,
  supportBgInfo: colors.lightBlue,
};
